// extracted by mini-css-extract-plugin
module.exports = {"card":"jgp-1Y3h5","card_image":"jgp-3qwq0","card_content_wrapper":"jgp-KVTAM","link":"jgp-35S96","fundraiser_details":"jgp-2uNFP","fundraiser_name":"jgp-27dNm"};